




















import Vue from 'vue'
import Component from 'vue-class-component'
import {Action, State} from 'vuex-class'
import DepartmentType from '@/modules/reservation/model/DepartmenType'
import {Prop} from 'vue-property-decorator'

/**
 * Selección del tipo de departamento
 *
 * Componente encargado de mostrar al usuario la lista de tipos de departamentos
 * disponibles. Además le permite seleccionar uno
 */
@Component
export default class DepartmentTypeSelect extends Vue {
    /**
     * Tipo de departamento seleccionado actualmente
     */
    @Prop({type: DepartmentType, default: () => (new DepartmentType())})
    public value: DepartmentType

    @Prop({type: String, default: 'Selecciona un tipo de departamento'})
    public label: string

    @Prop({type: String, default: ''})
    public placeholder: string

    /**
     * Reglas de validación
     */
    @Prop({type: Array, default: () => []})
    public rules: Array<() => true | string>

    @Prop({type: Boolean, default: false})
    public hideDetails: boolean

    @Prop({type: Boolean, default: false})
    public dense: boolean

    @Prop({type: Boolean, default: true})
    public clearable: boolean

    /**
     * Lista con los tipos de departamentos cargados en el estado de la aplicación
     */
    @State(state => state.reservation.departmentTypes)
    public types: DepartmentType[]

    /**
     * Solicita a la aplicación que cargue la lista de tipos de departamentos
     */
    @Action('reservation/loadDepartmentTypeList')
    public loadType: (options?: { force?: boolean }) => any

    public loading = true

    public async created () {
        await this.loadType()
        this.loading = false
    }
}
